/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Reference to an explore playlist
 * @export
 * @interface PlaylistLibraryExplorePlaylistIdentifier
 */
export interface PlaylistLibraryExplorePlaylistIdentifier {
    /**
     * 
     * @type {string}
     * @memberof PlaylistLibraryExplorePlaylistIdentifier
     */
    type: PlaylistLibraryExplorePlaylistIdentifierTypeEnum;
    /**
     * Explore playlist identifier
     * @type {string}
     * @memberof PlaylistLibraryExplorePlaylistIdentifier
     */
    playlistId: string;
}


/**
 * @export
 */
export const PlaylistLibraryExplorePlaylistIdentifierTypeEnum = {
    ExplorePlaylist: 'explore_playlist'
} as const;
export type PlaylistLibraryExplorePlaylistIdentifierTypeEnum = typeof PlaylistLibraryExplorePlaylistIdentifierTypeEnum[keyof typeof PlaylistLibraryExplorePlaylistIdentifierTypeEnum];


/**
 * Check if a given object implements the PlaylistLibraryExplorePlaylistIdentifier interface.
 */
export function instanceOfPlaylistLibraryExplorePlaylistIdentifier(value: object): value is PlaylistLibraryExplorePlaylistIdentifier {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "playlistId" in value && value["playlistId"] !== undefined;

    return isInstance;
}

export function PlaylistLibraryExplorePlaylistIdentifierFromJSON(json: any): PlaylistLibraryExplorePlaylistIdentifier {
    return PlaylistLibraryExplorePlaylistIdentifierFromJSONTyped(json, false);
}

export function PlaylistLibraryExplorePlaylistIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistLibraryExplorePlaylistIdentifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'playlistId': json['playlist_id'],
    };
}

export function PlaylistLibraryExplorePlaylistIdentifierToJSON(value?: PlaylistLibraryExplorePlaylistIdentifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'playlist_id': value.playlistId,
    };
}

